import { forwardRef } from "react"

import { cn } from "@/lib/utils"

export type IconWrapper = {
  className?: string
  children: React.ReactNode
}

export const IconWrapper = forwardRef(function Card(
  { className, children }: IconWrapper,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div ref={ref} className={cn("w-fit rounded-full p-1.5 text-[32px]", className)}>
      {children}
    </div>
  )
})
